import { Serializable } from './../deserialize.service';
import { TelemedUnread } from './telemedUnread.model';

export class TelemedRead implements Serializable<TelemedRead> {
    unreads: TelemedUnread[];

    deserialize(input) {
        this.unreads = input.unreads;
        return this;
    }
}
